/* <product-info>: variant selection, gallery thumbs, sticky add-to-cart. */
(function () {
  class ProductInfo extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.pdp') || this;
      var json = this.querySelector('script[data-variants]');
      this.variants = json ? JSON.parse(json.textContent) : [];
      this.form = this.querySelector('form');
      this.idInput = this.querySelector('[data-variant-id]');
      this.slider = this.querySelector('slider-component');
      this.sticky = this.section.querySelector('[data-sticky-atc]');
      this.addEventListener('change', function (e) { if (e.target.matches('input[type="radio"]')) this.onOption(); }.bind(this));
      this.querySelectorAll('[data-thumb]').forEach(function (b) {
        b.addEventListener('click', function () { this.slider && this.slider.goTo(parseInt(b.dataset.thumb, 10)); }.bind(this));
      }, this);
      var track = this.querySelector('[data-slider-track]');
      if (track) track.addEventListener('scroll', this.syncThumbs.bind(this), { passive: true });
      this.setupSticky();
    }
    syncThumbs() {
      if (!this.slider || !this.slider.currentIndex) return;
      var i = this.slider.currentIndex();
      this.querySelectorAll('[data-thumb]').forEach(function (b) {
        if (parseInt(b.dataset.thumb, 10) === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
    }
    selected() {
      return Array.prototype.map.call(this.querySelectorAll('.variant-option'), function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    onOption() {
      var sel = this.selected();
      this.querySelectorAll('.variant-option').forEach(function (fs) {
        var c = fs.querySelector('input:checked'), out = fs.querySelector('[data-option-value]');
        if (c && out) out.textContent = c.value;
      });
      var v = this.variants.filter(function (variant) {
        return variant.options.every(function (o, i) { return o === sel[i]; });
      })[0];
      this.applyVariant(v);
    }
    applyVariant(v) {
      var atcs = this.section.querySelectorAll('[data-atc]');
      var labels = this.section.querySelectorAll('[data-atc-label]');
      var t = (window.JM && JM.strings) || {};
      if (!v) {
        atcs.forEach(function (b) { b.disabled = true; });
        labels.forEach(function (l) { l.textContent = t.unavailable || 'Unavailable'; });
        return;
      }
      if (this.idInput) { this.idInput.value = v.id; this.idInput.disabled = !v.available; }
      atcs.forEach(function (b) { b.disabled = !v.available; });
      labels.forEach(function (l) { l.textContent = v.available ? (l.dataset.addLabel || 'Add to cart') : (l.dataset.soldLabel || 'Sold out'); });
      var cur = this.querySelector('[data-price-current]'), cmp = this.querySelector('[data-price-compare]'), badge = this.querySelector('[data-price-badge]');
      var fmt = (window.JM && JM.formatMoney) ? JM.formatMoney : function (n) { return n / 100; };
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (cur) { cur.textContent = fmt(v.price); cur.style.color = onSale ? '' : 'var(--ink)'; }
      if (cmp) { cmp.hidden = !onSale; cmp.textContent = onSale ? fmt(v.compare_at_price) : ''; }
      if (badge) {
        badge.hidden = !onSale;
        if (onSale) badge.textContent = badge.dataset.template ? badge.dataset.template.replace('%', Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price)) : 'Save ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
      }
      var sb = this.section.querySelector('[data-sale-badge]');
      if (sb) {
        sb.hidden = !onSale;
        if (onSale) sb.textContent = (badge && badge.textContent) || ('Save ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%');
      }
      var sp = this.section.querySelector('[data-sticky-price]');
      if (sp) sp.textContent = fmt(v.price);
      if (v.featured_media && this.slider) {
        var pos = v.featured_media.position - 1;
        if (pos >= 0) this.slider.show(pos);
      }
      if (history.replaceState) history.replaceState({}, '', this.dataset.url + '?variant=' + v.id);
    }
    setupSticky() {
      var buy = this.querySelector('[data-buy-buttons]');
      if (!this.sticky || !buy || !('IntersectionObserver' in window)) return;
      this.sticky.hidden = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var below = en.boundingClientRect.top > 0;
          this.sticky.classList.toggle('is-visible', !en.isIntersecting && !below);
        }.bind(this));
      }.bind(this));
      io.observe(buy);
    }
  }
  if (!customElements.get('product-info')) customElements.define('product-info', ProductInfo);
})();
